/**
 * calendarConstants.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Constantes do calendário v2 — configurações, modos e labels em pt-BR.
 *
 * @module calendarConstants
 */

// ── Alturas de slot ───────────────────────────────────────────────────────────

/** Altura em pixels por hora no modo confortável */
export const SLOT_HEIGHT_COMFORTABLE = 80;

/** Altura em pixels por hora no modo compacto */
export const SLOT_HEIGHT_COMPACT = 48;

/** Intervalo em minutos por slot */
export const SLOT_INTERVAL = 30;

// ── Horários padrão ───────────────────────────────────────────────────────────

/** Hora de início padrão do calendário */
export const DEFAULT_START_HOUR = 7;

/** Hora de fim padrão do calendário */
export const DEFAULT_END_HOUR = 20;

// ── Modos de visualização ─────────────────────────────────────────────────────

/**
 * Modos de visualização disponíveis no calendário.
 * @enum {string}
 */
export const VIEW_MODES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

// ── Modos de densidade ────────────────────────────────────────────────────────

/**
 * Modos de densidade visual do calendário.
 * @enum {string}
 */
export const DENSITY_MODES = {
  COMFORTABLE: 'comfortable',
  COMPACT: 'compact',
};

// ── Labels em pt-BR ───────────────────────────────────────────────────────────

/** Dias da semana abreviados em pt-BR (índice 0 = Domingo) */
export const WEEKDAYS_SHORT = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

/** Dias da semana completos em pt-BR (índice 0 = Domingo) */
export const WEEKDAYS_LONG = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

/** Meses do ano em pt-BR (índice 0 = Janeiro) */
export const MONTHS = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

/** Meses do ano abreviados em pt-BR (índice 0 = Jan) */
export const MONTHS_SHORT = [
  'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
  'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',
];

// ── Configurações de layout ───────────────────────────────────────────────────

/** Largura da coluna de horários (gutter esquerdo) em pixels */
export const TIME_GUTTER_WIDTH = 56;

/** Largura do drawer lateral em pixels */
export const DRAWER_WIDTH = 420;

/** Duração padrão de um novo agendamento em minutos */
export const DEFAULT_APPOINTMENT_DURATION = 50;

/** Número de dias exibidos na visão semanal */
export const WEEK_DAYS_COUNT = 7;
